<template>
  <div>
    <span v-if="row.miniFloatRateStr === '未设置'" class="color-gray">{{
      row.miniFloatRateStr
    }}</span>
    <span @click="onOpen" class="color-blue color-blue__underline" v-else>{{
      row.miniFloatRateStr
    }}</span>
    <el-dialog title="销售溢价变更明细" :visible.sync="dialogVisible" modal-append-to-body append-to-body destroy-on-close
      width="35%">
      <!-- 表格 -->
      <el-table ref="table" v-loading="table.loading" :data="table.dataSource" border height="400">
        <el-table-column prop="createTime" label="变更时间" width="280" />
        <el-table-column prop="commissionRateStr" label="变更后销售溢价" align="center" />
      </el-table>
      <!-- 分页-->
      <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
        @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();

export default {
  props: {
    row: {
      type: Object, // 行数据
      default: () => { },
    },
  },
  data() {
    return {
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
    };
  },

  methods: {
    // 批量操作
    onOpen() {
      this.dialogVisible = true;
      this.freshTable();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求列表
    async freshTable() {
      this.table.loading = true;
      const params = {
        ...this.pagination,
        relationId: this.row.id,
        type: 2,
      };
      const data = await DouYinModel.getRateChangeLog(params).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/CommissionRecord.vue